@if (isVisible()) {
  <div class="flex align-items-center justify-content-between w-full h-full">
    <div class="grow">
      <ng-content/>
    </div>

    <div class="flex align-items-center justify-content-end ml-2.5">
      <span class="w-fit"
            pTooltip="Clear override"
            tooltipPosition="left"
      >
        <button pButton
                type="button"
                class="clear-override-btn"
                outlined="true"
                severity="secondary"
                iconOnly
                [disabled]="isEffectiveDisabled()"
                (click)="visibilityChange.emit()"
        >
          <i class="pi pi-times"></i>
        </button>
      </span>
    </div>
  </div>
} @else {
  <div class="align-items-center justify-content-between w-full h-full hidden md:flex">
    <div class="grow"></div>
    <div class="flex align-items-center justify-content-end ml-2.5">
      <span class="w-fit"
            tooltipPosition="left"
            [pTooltip]="`Add Override for ${tooltipLabel()}`"
      >
        <button pButton
                type="button"
                class="add-override-btn"
                outlined="true"
                severity="primary"
                iconOnly
                [disabled]="isEffectiveDisabled()"
                (click)="visibilityChange.emit()"
        >
          <i class="pi pi-plus"></i>
        </button>
      </span>
    </div>
  </div>
}
